// ─── REVCENTRIQ PRICING TIERS ─────────────────────────────────────────────────
// Single source of truth for all pricing data.

export const PRICING = [
  {
    name: "Starter",
    price: 299,
    period: "mo",
    desc: "For early-stage teams getting visibility",
    modules: 3,
    users: 5,
    features: [
      "3 modules of your choice",
      "5 user seats",
      "CSV export",
      "Email support",
    ],
    popular: false,
    cta: "Start free trial",
  },
  {
    name: "Growth",
    price: 799,
    period: "mo",
    desc: "For scaling GTM teams that need depth",
    modules: 8,
    users: 20,
    features: [
      "8 modules",
      "20 user seats",
      "API access",
      "Slack alerts",
      "Priority support",
    ],
    popular: true,
    cta: "Start free trial",
  },
  {
    name: "Enterprise",
    price: null,
    period: null,
    desc: "Full suite for complex GTM organizations",
    modules: 12,
    users: null,
    features: [
      "All 12 modules",
      "Unlimited seats",
      "SSO / SAML",
      "Custom integrations",
      "Dedicated CSM",
    ],
    popular: false,
    cta: "Contact sales",
  },
];

// Founding customer offer (pre-sale)
export const FOUNDING_OFFER = {
  discount: 0.5,
  label: "Founding Customer",
  description: "50% off forever — locked at launch price",
  starterPrice: 149,
  growthPrice: 399,
};
